import TenDaysMVPReady from './TenDaysMVPReady';
export default TenDaysMVPReady;
